/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, July 2022
 * @format
 * @flow
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/Checkbox';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';
import classes from './ResendReceipt.module.css';

const ResendReceipt = ({
  selectedCheck,
  receiptHandler,
  onClose,
  currency,
}) => {
  const [selectedTickets, setSelectedTickets] = useState(new Map());
  const { tickets } = selectedCheck || {};

  const onSelectTicket = ticket => {
    let mapObj = new Map();
    mapObj.set(ticket.id, ticket);
    setSelectedTickets(mapObj);
  };

  const onReceiptAction = type => {
    const ticketArray = Array.from(selectedTickets.values());
    const ticket = ticketArray[0];
    receiptHandler(type, ticket);
  };

  return (
    <div className={classes.container}>
      <div className={classes.headerWrapper}>
        <div className={classes.backButton} onClick={onClose}>
          <img src={backImg} className={classes.backImage} alt="Back" />
        </div>
      </div>
      <Header />
      <div className={classes.contentWrapper}>
        {tickets.map(ticket => (
          <div className={classes.row} key={`ticket-${ticket.id}`}>
            <div className={[classes.contentTxt, classes.checkboxCol].join(' ')}>
              <Checkbox checked={selectedTickets.has(ticket.id)} onChange={() => onSelectTicket(ticket)} />
            </div>
            <div className={[classes.contentTxt, classes.typeCol].join(' ')}>{ticket.cardType}</div>
            <div className={[classes.contentTxt, classes.cardCol].join(' ')}>{ticket.redactedCardNumber}</div>
            <div className={[classes.contentTxt, classes.nameCol].join(' ')}>{ticket.cardHolderName}</div>
            <div className={[classes.contentTxt, classes.totalCol].join(' ')}>{currency}{ticket.ticketAmount}</div>
            <div className={[classes.contentTxt, classes.tipCol].join(' ')}>{currency}{ticket.tipAmount}</div>
            <div className={[classes.contentTxt, classes.paymentCol].join(' ')}>{ticket.ticketTypeId === 1 ? 'Payment' : 'Refund'}</div>
          </div>
        ))}
      </div>
      <div className={classes.buttonsWrapper}>
        <Button
          disabled={selectedTickets.size === 0}
          className={classes.button}
          onClick={() => onReceiptAction('print')}>
          Print
        </Button>
        <Button
          disabled={selectedTickets.size === 0}
          className={classes.button}
          onClick={() => onReceiptAction('email')}>
          Email
        </Button>
        <Button
          disabled={selectedTickets.size === 0}
          className={classes.button}
          onClick={() => onReceiptAction('text')}>
          Text
        </Button>
      </div>
    </div>
  )
};

export default ResendReceipt;

ResendReceipt.propTypes = {
  selectedCheck: PropTypes.object,
  receiptHandler: PropTypes.func,
  onClose: PropTypes.func,
  currency: PropTypes.string,
};

ResendReceipt.defaultProps = {
  selectedCheck: {},
  receiptHandler: () => { },
  onClose: () => { },
  currency: '$',
};

const Header = () => (
  <div className={classes.row}>
    <div className={[classes.headerTitle, classes.checkboxCol].join(' ')}>Select</div>
    <div className={[classes.headerTitle, classes.typeCol].join(' ')}>Type</div>
    <div className={[classes.headerTitle, classes.cardCol].join(' ')}>Card#</div>
    <div className={[classes.headerTitle, classes.nameCol].join(' ')}>Name</div>
    <div className={[classes.headerTitle, classes.totalCol].join(' ')}>Total</div>
    <div className={[classes.headerTitle, classes.tipCol].join(' ')}>Tip</div>
    <div className={[classes.headerTitle, classes.paymentCol].join(' ')}>Payment/Refund</div>
  </div>
);
